import React, { useRef } from 'react';
var VeltInlineCommentsSectionSortingDropdownTriggerName = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-trigger-name", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltInlineCommentsSectionSortingDropdownTriggerName;
